(function () {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const BOX_ID = 'RecommendationsContainer';
  let loading = false;

  const money = (v) => 'LE ' + (typeof v === 'string' ? parseFloat(v) : v / 100).toFixed(2);
  const esc = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function normalize(p) {
    const variants = p.variants || [];
    const v = variants.find((x) => x.available !== false) || variants[0];
    if (!v || p.available === false) return null;
    const img =
      typeof p.featured_image === 'string'
        ? p.featured_image
        : (p.featured_image && p.featured_image.src) ||
          (p.images && (p.images[0].src || p.images[0])) ||
          '';
    const compare = v.compare_at_price;
    const showCompare = compare && parseFloat(compare) > 0 && parseFloat(compare) > parseFloat(v.price);
    return {
      id: p.id,
      title: p.title,
      url: root + 'products/' + p.handle,
      image: img,
      variantId: v.id,
      price: money(v.price),
      compare: showCompare ? money(compare) : ''
    };
  }

  function card(p) {
    return `
      <div class="recommendation-card">
        <a href="${p.url}" class="recommendation-card__image">
          <img src="${p.image}" alt="${esc(p.title)}" width="150" height="150" loading="lazy">
        </a>
        <div class="recommendation-card__content">
          <h4 class="recommendation-card__title">${esc(p.title)}</h4>
          <div class="recommendation-card__price">
            <span class="price">${p.price}</span>
            ${p.compare ? `<span class="price--strike">${p.compare}</span>` : ''}
          </div>
          <button type="button" class="button button--secondary" data-add-rec data-variant-id="${p.variantId}">Add</button>
        </div>
      </div>`;
  }

  async function load() {
    const box = document.getElementById(BOX_ID);
    if (!box || box.dataset.loaded || loading) return;
    loading = true;
    try {
      const cart = await (await fetch(root + 'cart.js')).json();
      if (!cart.items.length) return;
      box.dataset.loaded = '1';
      const inCart = new Set(cart.items.map((i) => i.product_id));

      let list = [];
      try {
        const r = await fetch(
          `${root}recommendations/products.json?product_id=${cart.items[0].product_id}&limit=8&intent=related`
        );
        if (r.ok) list = (await r.json()).products || [];
      } catch (e) {}
      list = list.filter((p) => !inCart.has(p.id));

      if (list.length < 3) {
        const r = await fetch(root + 'collections/all/products.json?limit=12');
        if (r.ok) {
          const extra = (await r.json()).products.filter(
            (p) => !inCart.has(p.id) && !list.some((x) => x.id === p.id)
          );
          list = list.concat(extra);
        }
      }

      const cards = list.map(normalize).filter(Boolean).slice(0, 3);
      const section = document.getElementById('CartDrawer-Recommendations');
      if (!cards.length) {
        if (section) section.style.display = 'none';
        return;
      }
      box.innerHTML = cards.map(card).join('');
    } catch (e) {
      console.error('CartRecommendations:', e);
    } finally {
      loading = false;
    }
  }

  async function add(button) {
    const drawer = document.querySelector('cart-drawer');
    button.disabled = true;
    button.textContent = 'Adding...';
    try {
      const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(button.dataset.variantId),
          quantity: 1,
          sections,
          sections_url: window.location.pathname
        })
      });
      if (!res.ok) throw new Error('add failed');
      const data = await res.json();
      if (drawer && drawer.renderContents) drawer.renderContents(data);
    } catch (e) {
      console.error('CartRecommendations add:', e);
      button.disabled = false;
      button.textContent = 'Try again';
    }
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add-rec]');
    if (b) add(b);
  });

  let t;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(load, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', load);
})();